/** Production URLs for this tool (subdomain) */
export const seoConfig = {
  siteName: 'Pixel Utility',
  siteUrl: 'https://clothing-shoe-size-converter.pixelutility.com',
  parentBrandUrl: 'https://pixelutility.com',
  canonicalPath: '/',
  defaultOgImage: '/logo512.png',
  locale: 'en_US',
  twitterHandle: '', // e.g. '@pixelutility' when available
};

export function getCanonicalUrl(pathname = seoConfig.canonicalPath) {
  const path = (pathname || '/').split('?')[0] || '/';
  return `${seoConfig.siteUrl}${path}`;
}
